
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ae-en/theme-parks",
      function () {
        return require("private-next-pages/ae-en/theme-parks.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ae-en/theme-parks"])
      });
    }
  